import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HandholeService } from '../../../../../shared/services/fiber-management/handhole.service.mjs';
import { IHandhole } from '@rfm/shared-interfaces';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CommonModule } from '@angular/common';
import { TableModule } from 'primeng/table';
interface OrderDetail {
  title: string;
  description: string;
  extra: string;
  image: string;
}

interface OrderInfo {
  value: string;
  label: string;
}

interface OrderItem {
  name: string;
  size: string;
  price: number;
}
@Component({
  selector: 'app-handhole-view',
  standalone: true,
  imports: [CommonModule, CardModule, ButtonModule, ProgressSpinnerModule,TableModule],
  templateUrl: './handhole-view.component.html',
  styleUrls: ['./handhole-view.component.scss'],
})
export class HandholeViewComponent implements OnInit {
  handhole: IHandhole | null = null; // Store the selected handhole details
  isLoading = false;
  orderDetails: OrderDetail[] = [
    {
      title: 'Service Details',
      description: 'Website Development',
      extra: 'Includes design, development, and deployment',
      image: '/images/service.png'
    },
    {
      title: 'Billing Details',
      description: 'Invoice #INV12345',
      extra: 'Due date: 15 Feb, 2025',
      image: '/images/billing.png'
    },
    {
      title: 'Payment Details',
      description: 'Credit Card Payment',
      extra: 'Paid on: 02 Feb, 2025',
      image: '/images/payment.png'
    },
    {
      title: 'Customer Info',
      description: 'John Doe',
      extra: 'john.doe@example.com',
      image: '/images/customer.png'
    }
  ];

  orderInfo: OrderInfo[] = [
    { value: '#TWT501', label: 'Order ID' },
    { value: '02 Jan, 2025', label: 'Order Date' },
    { value: '09 Jan, 2025', label: 'Delivery Date' },
    { value: '$120.49', label: 'Order Amount' },
    { value: 'Delivered', label: 'Order Status' }
  ];

  orderItems: OrderItem[] = [
    { name: 'Website Design Package', size: 'Standard', price: 80.00 },
    { name: 'Hosting (1 Year)', size: 'Basic', price: 30.00 },
    { name: 'Domain Registration', size: '1 Year', price: 10.00 }
  ];
  constructor(private route: ActivatedRoute, private handholeService: HandholeService) {}

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.loadHandhole(id);
    }
  }

  loadHandhole(id: string): void {
    this.handholeService.get(id)
      .then((response) => {
        this.handhole = response?.data ?? null; // Handle null or undefined data
        this.isLoading = false;
      })
      .catch((error) => {
        console.error('Error fetching handhole details:', error);
        this.isLoading = false;
      });
  }
}
